import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
    selector: 'odq-add-button',
    templateUrl: './add-button.component.html',
    styleUrls: ['./add-button.component.scss'],
    standalone: false
})
export class AddButtonComponent implements OnInit {

  @Output() clicked = new EventEmitter();
  @Input() label: string;

  constructor() { }

  ngOnInit() {
  }

  onClick() {
    this.clicked.emit();
  }

}
